// extracted by mini-css-extract-plugin
module.exports = {"v1jzzp9x":"v1jzzp9x"};